var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTranscript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9535 0.937012H0.71875V29.062H24.7344V8.98621L16.9535 0.937012ZM22.9219 9.76281V9.84326H16.125V2.81201H16.2028L22.9219 9.76281ZM2.53125 27.187V2.81201H14.3125V11.7183H22.9219V27.187H2.53125Z",
    fill: "#30426D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranscript);
export default __webpack_public_path__ + "static/media/transcript.c6b24b0235a4341d2d5bcd428ba7296e.svg";
export { ForwardRef as ReactComponent };